module.exports = __webpack_public_path__ + "static/media/uk.7f0f53d3.svg";